module.exports = __webpack_public_path__ + "img/customise_character.d5239655.svg";